/**
 * Stop the BROWSER autofilling a field.
 *
 * Why this is needed at all: staff enter many different people's details into
 * the same form on the same origin. The browser remembers every one of them and
 * then offers a previous client's address, phone or name while a different
 * client's record is open. Nothing is leaking from the API — those values were
 * saved locally by the browser from earlier form submissions — but the effect is
 * that other clients' personal data appears on screen, and one mis-click files
 * it against the wrong person.
 *
 * `autocomplete="off"` alone is NOT enough: Chrome deliberately ignores it for
 * fields it recognises as address / name / telephone, on the grounds that users
 * want their own details filled in. That reasoning does not hold for a CRM,
 * where the operator is never the subject of the form.
 *
 * The reliable lever is an UNRECOGNISED token — the browser has no heuristic to
 * attach to it, so it offers nothing. It is unique per field so the browser
 * cannot group several fields into one address "section" and fill them together.
 */
export const noAutofillProps = (name = "field") => ({
  autoComplete: `no-autofill-${name}`,
  // Belt and braces for the password manager heuristics in Safari/Firefox.
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-form-type": "other",
});

export default noAutofillProps;
